import React, { createContext, useContext } from "react";
import { View } from "@react-pdf/renderer";

const PageReferencesContext = createContext(null);

const PageReferencesProvider = ({ pageReferences, children }) => (
    <PageReferencesContext.Provider value={pageReferences}>
        {children}
    </PageReferencesContext.Provider>
);

const usePageReferences = () => useContext(PageReferencesContext);

const PageReference = ({ id }) => {
    const pageReferences = usePageReferences();

    if (!id || !pageReferences) {
        return null;
    }

    return (
        <View
            wrap={false}
            render={({ pageNumber }) => {
                if (pageNumber) {
                    pageReferences.current.set(id, pageNumber);
                }

                return null;
            }}
        />
    );
};

export {
    PageReference,
    PageReferencesProvider,
    usePageReferences,
};
